/* 이용안내 · FAQ 공용 탭.
   해시로 들어온 링크를 살리는 게 핵심이다. /pages/guide#shipping 처럼
   블록 앵커를 가리키는 기존 링크(상품 페이지 아코디언 포함)가 여럿 있어서,
   해시가 어느 탭 안에 있는지 찾아 그 탭을 열고 해당 위치로 스크롤한다. */
if (!customElements.get('tengergo-tabs')) {
  class TengerGoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      this.classList.add('tg-tabs--enhanced');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.applyHash();
      window.addEventListener('hashchange', () => this.applyHash());
    }

    applyHash() {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''));
      if (!hash) return;

      const panel = this.querySelector(`[data-panel="${CSS.escape(hash)}"]`);
      if (panel) {
        this.select(hash, false);
        panel.scrollIntoView({ block: 'start' });
        return;
      }

      const target = this.querySelector(`#${CSS.escape(hash)}`);
      if (!target) return;

      const owner = target.closest('[role="tabpanel"]');
      if (!owner) return;

      this.select(owner.dataset.panel, false);
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    select(key, focusTab) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
        if (active && focusTab) tab.focus();
        // 탭 막대가 가로 스크롤 상태면 선택된 탭을 가운데로 (세로 이동 없음)
        if (active) {
          const nav = tab.parentElement;
          if (nav && nav.scrollWidth > nav.clientWidth + 1) {
            const left = tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2;
            const max = nav.scrollWidth - nav.clientWidth;
            // 일부 환경에서 smooth 애니메이션이 취소되므로 직접 대입한다
            nav.scrollLeft = Math.min(Math.max(0, left), max);
          }
        }
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.panel === key;
        panel.hidden = !active;
      });
    }

    onKeydown(event) {
      const index = this.tabs.indexOf(event.target);
      if (index === -1) return;

      let next = null;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;

      event.preventDefault();
      this.select(this.tabs[next].dataset.tab, true);
    }
  }

  customElements.define('tengergo-tabs', TengerGoTabs);
}
